import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useT } from "../i18n";
import LangSwitcher from "../components/LangSwitcher";
import { Lock, ArrowRight, Eye, EyeSlash } from "@phosphor-icons/react";

export default function Login() {
    const { login, error } = useAuth();
    const { t } = useT();
    const nav = useNavigate();
    const [pw, setPw] = useState("");
    const [show, setShow] = useState(false);
    const [busy, setBusy] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!pw) return;
        setBusy(true);
        const ok = await login(pw);
        setBusy(false);
        if (ok) nav("/galerie", { replace: true });
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg)" }}>
            <div className="grain" />
            <div className="relative z-10 w-full max-w-md">
                <div className="flex justify-between items-start mb-10">
                    <div>
                        <div className="label-mono mb-3">{t("login_pre")}</div>
                        <h1 className="heading-tight text-4xl sm:text-5xl tracking-tight">
                            {t("login_h1_1")}
                            <br />
                            <span style={{ color: "var(--text-muted)" }}>{t("login_h1_2")}</span>
                        </h1>
                    </div>
                    <LangSwitcher />
                </div>

                <form
                    onSubmit={onSubmit}
                    className="border p-6 sm:p-8"
                    style={{ borderColor: "var(--border)", background: "var(--surface)" }}
                >
                    <label className="label-mono mb-3 block">{t("login_label")}</label>
                    <div className="flex items-center border" style={{ borderColor: "var(--border-strong)", background: "var(--bg)" }}>
                        <div className="px-3" style={{ color: "var(--text-muted)" }}>
                            <Lock size={18} />
                        </div>
                        <input
                            data-testid="input-password"
                            type={show ? "text" : "password"}
                            value={pw}
                            onChange={(e) => setPw(e.target.value)}
                            autoFocus
                            placeholder={t("login_placeholder")}
                            className="flex-1 h-12 bg-transparent outline-none text-base"
                            style={{ color: "var(--text)" }}
                        />
                        <button
                            type="button"
                            data-testid="btn-toggle-password"
                            onClick={() => setShow((v) => !v)}
                            className="px-3 h-12 btn-press"
                            style={{ color: "var(--text-muted)" }}
                        >
                            {show ? <EyeSlash size={18} /> : <Eye size={18} />}
                        </button>
                    </div>

                    {error && (
                        <div
                            data-testid="login-error"
                            className="mt-4 px-3 py-2 text-sm border"
                            style={{ borderColor: "var(--danger)", color: "var(--danger)" }}
                        >
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        data-testid="btn-login"
                        disabled={busy || !pw}
                        className="mt-6 w-full h-12 flex items-center justify-center gap-2 btn-press disabled:opacity-50"
                        style={{ background: "var(--text)", color: "var(--bg)" }}
                    >
                        <span className="text-sm font-medium">{busy ? t("login_btn_busy") : t("login_btn")}</span>
                        {!busy && <ArrowRight size={18} />}
                    </button>
                </form>

                <div className="mt-8 label-mono" style={{ color: "var(--text-dim)" }}>
                    admin · galerie · descărcări · qr code
                </div>
            </div>
        </div>
    );
}
